import { cooperplaceApi } from 'services/api';

export async function validateDriver({
  originScheduledTime,
  destinationScheduledTime,
  driverId,
  travelId,
}) {
  const validation = {
    travels: [],
    isOnAnotherTravel: false,
  };

  const response = await cooperplaceApi.get('travels/validateDriver', {
    params: {
      originScheduledTime,
      destinationScheduledTime,
      driverId,
      travelId,
    },
  });

  const { travels } = response.data;
  validation.travels = travels;
  validation.isOnAnotherTravel = !!travels.length;
  return validation;
}
